import React from 'react';

export const Footer = (props) => {
  return (
    <div>
      <div id='footer'>
        <div className='container text-center'>
          <p>
            &copy; WakingCorp 2024 All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};
